module.exports = __webpack_public_path__ + "static/media/usa.7e656f6b.png";